import { Observable } from 'rxjs'
import { NewOrgModel } from '../models/new-org-model'
import { OrgTableModel } from '../models/org-table-model'
import { OrgTrainingModel } from '../models/org-training-model'
import { OrgSettingsModel } from '../models/org-settings-model'
import { AppFeatureSettingValue } from '../models/app-feature-setting-value'
import { OrgLicense } from '../models/org-license'
import { AddOrgLicense } from '../models/add-org-license'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { OrgTableFilter } from '../models/orgTable-filter'

export abstract class EditFmoAbstractGateway {
    abstract getOrgDetail(orgId: number): Observable<NewOrgModel>

    abstract updateOrgData(model: NewOrgModel): Observable<any>

    abstract getOrgTable(filter: OrgTableFilter): Observable<OrgTableModel[]>

    abstract getOrgTraining(orgId: number): Observable<OrgTrainingModel[]>

    abstract getOrgSettings(orgId: number, featureName: string): Observable<OrgSettingsModel[]>

    abstract insertOrgTraining(model: OrgTrainingModel): Observable<any>

    abstract deleteOrgTraining(orgCourseId: number, orgId: number): Observable<any>

    abstract deleteOrgPlan(cagId: number, orgId: number, planyear: string): Observable<any>

    abstract saveFmoSetting(settingModel: AppFeatureSettingValue[]): Observable<any>

    abstract getOrgSettingValueBySettingName(orgId: number, featureName: string, settingName: string): Observable<OrgSettingsModel[]>

    abstract getOrgLicenses(orgId: number): Observable<OrgLicense[]>

    abstract addOrgLicenses(model: AddOrgLicense): Observable<any>
    abstract addAllOrgLicenses(model: AddOrgLicense): Observable<any>
    abstract deleteOrgLicense(orgLicenseId: number, orgId: number): Observable<any>

    abstract getAllLicenseStatus(): Observable<ValidatedSelectOptionModel[]>
}
